import { useState, useRef, useCallback, useEffect } from "react";

const SLIDES = [
  { title: null,                                    img: "mlounge-img-001", isVideo: true,  videoSrc: "https://mgmotor.scene7.com/is/content/mgmotor/mlounge-vid-001" },
  { title: "Galaxy View Roof",                      img: "mlounge-img-002", isVideo: false },
  { title: "Multi-Mode Massage & Ventiluxe Seats",  img: "mlounge-img-003", isVideo: false },
  { title: "JBL Studio 12 Sound System",            img: "mlounge-img-004", isVideo: false },
  { title: "64 Colour Ambient Light",               img: "mlounge-img-005", isVideo: false },
  { title: "12 Way Powered Seats",                  img: "mlounge-img-006", isVideo: false },
  { title: "Majestic Rear Space",                   img: "mlounge-img-007", isVideo: false },
  { title: "Expansive Boot Space",                  img: "mlounge-img-008", isVideo: false },
];

const imgUrl = (name) =>
  `https://mgmotor.scene7.com/is/image/mgmotor/${name}?fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=90&hei=1080`;

const ARROW =
  "https://www.mgmotor.co.in/etc.clientlibs/mgmotor-redesign/clientlibs/clientlib-site/resources/icons/arrow-white.svg";

const N = SLIDES.length;

export default function MGMLounge() {
  const [active, setActive] = useState(0);
  const [animating, setAnimating] = useState(false);
  const touchStartX = useRef(null);
  const touchStartY = useRef(null);

  const navigate = useCallback((next) => {
    if (animating) return;
    setAnimating(true);
    setActive(next);
    setTimeout(() => setAnimating(false), 500);
  }, [animating]);

  const goPrev = () => navigate((active - 1 + N) % N);
  const goNext = () => navigate((active + 1) % N);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowLeft")  goPrev();
      if (e.key === "ArrowRight") goNext();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  });

  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  };
  const onTouchEnd = (e) => {
    const dx = touchStartX.current - e.changedTouches[0].clientX;
    const dy = Math.abs(touchStartY.current - e.changedTouches[0].clientY);
    if (Math.abs(dx) > 50 && dy < 60) dx > 0 ? goNext() : goPrev();
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,600;0,700;1,600;1,700&family=Barlow:wght@400;500&display=swap');
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}

        .ml{
        //   background:#e5e5e5;
          overflow:hidden;
          font-family:'Barlow',sans-serif;
        }

        /* ══ HEADER ══ */
        .ml-head{
          padding:clamp(24px,4vw,40px) 0 clamp(14px,2vw,22px) 4.5%;
        }
        .ml-head__title{
          font-family:'Barlow Condensed',sans-serif;
          font-style:italic;
          font-weight:700;
          font-size:clamp(18px,2vw,26px);
          letter-spacing:.07em;
          text-transform:uppercase;
          color:#111;
          line-height:1;
        }
        .ml-head__sub{
          margin-top:6px;
          font-size:clamp(12px,1.1vw,15px);
          color:#444;
        }

        /* ══ CAROUSEL OUTER ══
           overflow-x hidden to clip side slides,
           overflow-y visible so the taller active slide shows fully */
        .ml-carousel{
          position:relative;
          width:100%;
          /* vertical padding so the active slide's extra height is visible */
          padding-top:clamp(14px,2.5vw,32px);
          padding-bottom:clamp(28px,5vw,52px);
          overflow-x:hidden;
          overflow-y:visible;
        }

        /* ══ TRACK
           Height = peek slide height.
           Active slide will have negative top + greater height to grow upward+downward */
        .ml-track{
          position:relative;
          width:100%;
          /* base height = peek height */
          height:clamp(195px,28vw,370px);
        }

        /* ══ SLIDE ══ */
        .ml-slide{
          position:absolute;
          border-radius:16px;
          overflow:hidden;
          background:#111;
          cursor:pointer;
          will-change:top,height,left,opacity;
          transition:
            left      .45s cubic-bezier(.4,0,.2,1),
            width     .45s cubic-bezier(.4,0,.2,1),
            top       .45s cubic-bezier(.4,0,.2,1),
            height    .45s cubic-bezier(.4,0,.2,1),
            opacity   .45s cubic-bezier(.4,0,.2,1),
            box-shadow .45s cubic-bezier(.4,0,.2,1);
        }

        .ml-slide--active{
          box-shadow: 0 20px 60px rgba(0,0,0,.38);
        }

        /* image */
        .ml-slide img{
          width:100%;
          height:100%;
          object-fit:cover;
          object-position:center;
          display:block;
          pointer-events:none;
          transition: filter .45s, transform .55s cubic-bezier(.4,0,.2,1);
        }
        /* dim side peeks */
        .ml-slide:not(.ml-slide--active) img{
          filter:brightness(.52);
        }
        /* subtle zoom-in on image when it becomes active */
        .ml-slide--active img{
          transform:scale(1.04);
        }
        .ml-slide:not(.ml-slide--active) img{
          transform:scale(1);
        }

        /* play icon */
        .ml-slide__play{
          position:absolute;
          inset:0;
          display:flex;
          align-items:center;
          justify-content:center;
          pointer-events:none;
          opacity:0;
          transition:opacity .35s;
        }
        .ml-slide--active .ml-slide__play{ opacity:1; }
        .ml-slide__play svg{
          width:clamp(44px,6vw,76px);
          height:clamp(44px,6vw,76px);
          filter:drop-shadow(0 2px 14px rgba(0,0,0,.5));
        }

        /* gradient */
        .ml-slide__grad{
          position:absolute;
          inset:0;
          background:linear-gradient(
            118deg,
            rgba(0,0,0,.52) 0%,
            rgba(0,0,0,.18) 38%,
            transparent 62%
          );
          pointer-events:none;
          opacity:0;
          transition:opacity .45s;
        }
        .ml-slide--active.ml-slide--has-title .ml-slide__grad{ opacity:1; }

        /* title */
        .ml-slide__title{
          position:absolute;
          top:clamp(16px,5%,38px);
          left:clamp(18px,5%,40px);
          right:clamp(10px,3%,20px);
          font-family:'Barlow Condensed',sans-serif;
          font-weight:700;
          color:#fff;
          line-height:1.1;
          text-shadow:0 2px 14px rgba(0,0,0,.55);
          pointer-events:none;
          transition:font-size .35s, opacity .35s;
        }
        .ml-slide--active .ml-slide__title{
          font-style:italic;
          font-size:clamp(22px,3.8vw,46px);
          letter-spacing:.01em;
          max-width:55%;
        }
        .ml-slide:not(.ml-slide--active) .ml-slide__title{
          font-style:normal;
          font-size:clamp(12px,1.5vw,18px);
          letter-spacing:.02em;
          max-width:85%;
        }

        /* ══ ARROWS ══ */
        .ml-arrow{
          position:absolute;
          /* vertically centre on the TRACK (not the taller active slide) */
          top:calc(clamp(14px,2.5vw,32px) + clamp(195px,28vw,370px)/2);
          transform:translateY(-50%);
          z-index:20;
          background:none;
          border:none;
          padding:0;
          cursor:pointer;
        }
        .ml-arrow--prev{ left:clamp(8px,1.2vw,18px); }
        .ml-arrow--next{ right:clamp(8px,1.2vw,18px); }

        .ml-arrow__circle{
          width:clamp(38px,4.8vw,52px);
          height:clamp(38px,4.8vw,52px);
          border-radius:50%;
          border:2px solid rgba(255,255,255,.72);
          background:rgba(10,10,10,.28);
          backdrop-filter:blur(8px);
          -webkit-backdrop-filter:blur(8px);
          display:flex;
          align-items:center;
          justify-content:center;
          transition:background .2s,border-color .2s,transform .15s;
        }
        .ml-arrow:hover .ml-arrow__circle{
          background:rgba(255,255,255,.2);
          border-color:#fff;
          transform:scale(1.08);
        }
        .ml-arrow:active .ml-arrow__circle{ transform:scale(.93); }
        .ml-arrow__circle img{
          width:clamp(13px,1.6vw,18px);
          height:clamp(13px,1.6vw,18px);
          display:block;
        }
        .ml-arrow--next .ml-arrow__circle img{ transform:rotate(180deg); }
        .ml-arrow__fb{ color:#fff;font-size:18px;line-height:1; }

        /* ══ RESPONSIVE ══ */
        @media(max-width:640px){
          .ml-head{ padding:18px 0 12px 4%; }
          .ml-track{ height:clamp(160px,44vw,240px); }
          .ml-carousel{
            padding-top:clamp(10px,2vw,20px);
            padding-bottom:clamp(20px,4vw,36px);
          }
          .ml-arrow{
            top:calc(clamp(10px,2vw,20px) + clamp(160px,44vw,240px)/2);
          }
          .ml-slide--active .ml-slide__title{ font-size:clamp(16px,5vw,24px);max-width:72%; }
          .ml-slide:not(.ml-slide--active) .ml-slide__title{ font-size:10px; }
        }
        @media(max-width:400px){
          .ml-track{ height:150px; }
          .ml-arrow{ top:calc(clamp(10px,2vw,20px) + 75px); }
        }
      `}</style>

      <section className="ml" aria-label="M-Lounge">

        <div className="ml-head">
          <h2 className="ml-head__title">m-lounge</h2>
          <p className="ml-head__sub">Not just a cabin–your private sanctuary on wheels.</p>
        </div>

        <div
          className="ml-carousel"
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
        >
          <SlideTrack
            slides={SLIDES}
            active={active}
            onSlideClick={(i) => { if (i !== active) navigate(i); }}
          />

          <button className="ml-arrow ml-arrow--prev" onClick={goPrev} aria-label="previous slide">
            <div className="ml-arrow__circle">
              <img src={ARROW} alt=""
                onError={(e) => { e.target.style.display="none"; e.target.parentNode.innerHTML='<span class="ml-arrow__fb">←</span>'; }}
              />
            </div>
          </button>

          <button className="ml-arrow ml-arrow--next" onClick={goNext} aria-label="next slide">
            <div className="ml-arrow__circle">
              <img src={ARROW} alt=""
                onError={(e) => { e.target.style.display="none"; e.target.parentNode.innerHTML='<span class="ml-arrow__fb">→</span>'; }}
              />
            </div>
          </button>
        </div>

      </section>
    </>
  );
}

/* ─────────────────────────────────────────────
   SlideTrack
   - active slide: taller + grows upward (negative top) + downward
   - peek slides: normal shorter height, vertically centred
───────────────────────────────────────────── */
function SlideTrack({ slides, active, onSlideClick }) {
  const [W, setW] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver(([e]) => setW(e.contentRect.width));
    ro.observe(el);
    setW(el.getBoundingClientRect().width);
    return () => ro.disconnect();
  }, []);

  /* ── sizing constants ── */
  const GAP         = 10;
  const ACTIVE_WRATIO = 0.74;  // active slide width ratio
  const PEEK_VISIBLE  = 0.115; // visible portion of side slide

  const activeW = W * ACTIVE_WRATIO;
  const peekW   = W * PEEK_VISIBLE;

  /* Track height (CSS) — peek slide height */
  const trackH  = (() => {
    if (typeof window === "undefined") return 300;
    const vw = window.innerWidth;
    if (vw <= 400) return 150;
    if (vw <= 640) return Math.min(240, Math.max(160, vw * 0.44));
    return Math.min(370, Math.max(195, vw * 0.28));
  })();

  /* Active slide is taller by this much (grows equally up + down) */
  const EXTRA_H = trackH * 0.22; // 22% taller

  const activeH = trackH + EXTRA_H;
  const peekH   = trackH;

  /* left position for each slide */
  const getLeft = (i) => {
    let d = i - active;
    if (d >  N / 2) d -= N;
    if (d < -N / 2) d += N;

    const centerLeft = (W - activeW) / 2;
    if (d === 0)  return centerLeft;
    if (d === 1)  return centerLeft + activeW + GAP;
    if (d === -1) return centerLeft - peekW - GAP;
    if (d > 1)    return centerLeft + activeW + GAP + (d - 1) * (peekW + GAP);
    return centerLeft - peekW - GAP + (d + 1) * (peekW + GAP);
  };

  const isVisible = (i) => {
    let d = Math.abs(i - active);
    if (d > N / 2) d = N - d;
    return d <= 1;
  };

  return (
    <div ref={ref} className="ml-track">
      {W > 0 && slides.map((slide, i) => {
        const isActive = i === active;
        const hasTitle = !!slide.title;
        const visible  = isVisible(i);

        const h    = isActive ? activeH : peekH;
        /* centre peeks vertically in the track; active grows above + below */
        const top  = isActive
          ? (trackH - activeH) / 2   /* negative → grows upward */
          : 0;                        /* peek: sits at top of track */

        return (
          <div
            key={slide.img}
            className={[
              "ml-slide",
              isActive ? "ml-slide--active"   : "",
              hasTitle ? "ml-slide--has-title" : "",
            ].join(" ").trim()}
            style={{
              left:    getLeft(i),
              width:   activeW,   /* all slides same width; peeks get cropped */
              top,
              height:  h,
              opacity: visible ? 1 : 0,
              zIndex:  isActive ? 5 : 2,
            }}
            onClick={() => {
              if (isActive && slide.isVideo) {
                window.open(slide.videoSrc, "_blank", "noopener,noreferrer");
              } else {
                onSlideClick(i);
              }
            }}
            role={isActive ? (slide.isVideo ? "link" : undefined) : "button"}
            tabIndex={isActive ? undefined : 0}
            aria-label={
              isActive
                ? slide.isVideo ? "Play M-Lounge video" : undefined
                : `Go to: ${slide.title || "video slide"}`
            }
            onKeyDown={(e) => e.key === "Enter" && onSlideClick(i)}
          >
            <img src={imgUrl(slide.img)} alt={slide.title || "M-Lounge"} loading="lazy" />

            <div className="ml-slide__grad" />

            {slide.isVideo && (
              <div className="ml-slide__play">
                <svg viewBox="0 0 80 80" fill="none">
                  <circle cx="40" cy="40" r="38" stroke="white" strokeWidth="2.5" />
                  <polygon points="32,24 60,40 32,56" fill="white" />
                </svg>
              </div>
            )}

            {hasTitle && (
              <h3 className="majestor-slider-carousel-slide--title ml-slide__title">
                {slide.title}
              </h3>
            )}
          </div>
        );
      })}
    </div>
  );
}